/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {FC} from 'react'
import { Route} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {MasterInit} from '../../_metronic/layout/MasterInit'
import { ErrorsPage } from '../modules/errors/ErrorsPage'


const Routes: FC = () => {
  return (
      <>
        <PrivateRoutes />
        <Route path='/error' component={ErrorsPage} />
        <MasterInit />
    </>
  )
}

export {Routes}
